module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/20mill-active-014b4956feeaee1092a26880a49b3f2d.png";